export default __webpack_public_path__ + "static/media/2023_Januar_Baum.1663fcea.webp";